import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const systemColors = themeColors.colors.system

const useStyles = makeStyles((theme) => ({
	fieldList: {
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(1)
	},
	fieldRow: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(1.5),
		padding: theme.spacing(1, 0),
		borderBottom: `1px solid ${theme.palette.divider}`
	},
	promotedFieldName: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(1),
		width: 200,
		flexShrink: 0
	},
	clickableChip: {
		cursor: "pointer"
	},
	extraFieldsCallout: {
		backgroundColor: systemColors.purple[50],
		borderRadius: theme.spacing(1),
		padding: theme.spacing(2)
	}
}))

export default useStyles
